module.exports = __webpack_public_path__ + "media/MRI2C.32355a2a.mp3";